import React from 'react';
import './HeroProposals.css';
function Hero() {
  return (
    <section className="hero hero-proposal-2">
      {/* Decorative floating shapes */}
      <div className="hero-shapes" aria-hidden="true">
        <div className="hero-shape shape-1" />
        <div className="hero-shape shape-2" />
        <div className="hero-shape shape-3" />
        <div className="hero-shape shape-4" />
        <div className="hero-shape shape-5" />
        <div className="hero-shape shape-6" />
      </div>

      <div className="container">
        <div className="hero-grid">
          <div className="hero-text-col">
            <div className="hero-tagline">Networking &amp; Aperitivo</div>
            <h1 className="hero-title">
              Business <span className="hero-accent">Date</span>
            </h1>
            <p className="hero-subtitle">Incontri, in modo smart.</p>
            <p className="hero-desc">
              Connetti con professionisti e imprenditori davanti a un aperitivo.
              Niente badge, niente formalità: solo persone interessanti e un buon drink.
            </p>
            <div className="hero-actions">
              <a href="#events" className="cta pulse-glow">Scopri i prossimi eventi →</a>
              <a href="#concept" className="cta-outline">Scopri di più</a>
            </div>
          </div>
          <div className="hero-visual-col">
            <div className="hero-visual-card hero-visual-card-img">
              <img src={`${process.env.PUBLIC_URL}/images/hero-background.png`} alt="" className="hero-visual-img" aria-hidden="true" />
              <div className="hero-visual-content">
                <div className="hero-visual-icon">🥂</div>
                <div className="hero-visual-lines">
                  <div className="v-line" />
                  <div className="v-line" />
                  <div className="v-line" />
                </div>
                <div className="hero-visual-dots">
                  <div className="v-dot" />
                  <div className="v-dot" />
                  <div className="v-dot" />
                  <div className="v-dot" />
                </div>
              </div>
              <div className="hero-visual-circle" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;